async function _deriveKey(secret) {
  const data = new TextEncoder().encode(secret);
  const hash = await crypto.subtle.digest("SHA-256", data);
  return new Uint8Array(hash);
}

function _base64ToBytes(value) {
  const binary = atob(value);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}

export async function decryptConfigPayload(payload, secret) {
  if (!payload || !secret) {
    throw new Error("Missing encrypted config payload or decryption key");
  }

  const combined = _base64ToBytes(payload);
  const nonce = combined.slice(0, 12);
  const ciphertext = combined.slice(12);
  const keyBytes = await _deriveKey(secret);
  const cryptoKey = await crypto.subtle.importKey(
    "raw",
    keyBytes,
    { name: "AES-GCM" },
    false,
    ["decrypt"]
  );

  const decrypted = await crypto.subtle.decrypt(
    { name: "AES-GCM", iv: nonce },
    cryptoKey,
    ciphertext
  );

  return JSON.parse(new TextDecoder().decode(decrypted));
}

export async function unwrapBackendConfigData(data) {
  if (!data?.encrypted) {
    return data;
  }

  const secret = process.env.REACT_APP_CONFIG_ENCRYPTION_KEY;
  if (!secret) {
    throw new Error(
      "REACT_APP_CONFIG_ENCRYPTION_KEY is required to decrypt backend config"
    );
  }

  return decryptConfigPayload(data.payload, secret);
}
